import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const profileConfig = {
  getProfileDetails: {
    key: "getProfileDetails",
    url: "/api/v1/auth/my-profile",
    method: "GET",
    options: {
      ...QUERY_PRESETS.REALTIME,
      refetchOnReconnect: true,
      retry: 2,
      keepPreviousData: true,
      meta: { description: "Fetch current user profile from pms-api" },
    },
  },
  updateMyProfile: {
    key: "updateMyProfile",
    url: "/api/v1/users/me",
    method: "PATCH",
    options: {
      invalidateKeys: ["getProfileDetails", "getMyProfile"],
      onSuccessMessage: "Profile updated successfully",
      onErrorMessage: "Failed to update profile",
      retry: false,
    },
  },

  updateProfileImage: {
    key: "updateProfileImage",
    url: (data) =>
      `/api/v1/users/${data instanceof FormData ? data.get("id") : data.id}/profile-image`,
    method: "POST",
    options: {
      invalidateKeys: ["getProfileDetails", "getMyProfile"],
      onSuccessMessage: "Profile image updated successfully",
      onErrorMessage: "Failed to update profile image",
      retry: false,
    },
  },
};
